import React, { useState } from "react";
import { MyDataTable } from "../partials/data-tables/data-table-fans.tsx";
import MainTabs from "../partials/main-tabs";
import FormModal from "../partials/form-modals/fans/new-form.jsx";
import FormConfigurationModal from "./lead-configuration.tsx";

const Fans = () => {
	const [isModalOpen, setModalOpen] = useState(false);
	const [isModalConfigOpen, setModalConfigOpen] = useState(false);

	return (
		<>
			<div class="main-tabs">
				<div class="mx-auto">
					<MainTabs tabIndexSelected={1} />
					<div id="myTabContent">
						<div class="flex justify-between w-full page-header">
							<div class="page-heading">
								<img src="../../../assets/icons/fan-icon.png" alt="Fans" class="icon" />
								<h2 class="text-4xl font-bold dark:text-white">
									<span class="text-transparent bg-clip-text bg-gradient-to-r to-fuchsia-700 from-violet-700">FANS</span>
								</h2>
							</div>
							<div>
								<div class="inline-flex rounded-md shadow-xs" role="group">
									<button
										disabled
										type="button"
										class="rounded-s-lg border border-r-0 text-slate-400 hover:text-cyan-700 border-slate-600 focus:outline-none focus:ring-2 focus:text-cyan-700 focus:ring-cyan-700 font-medium text-sm px-4 py-2 mb-2">
										List
									</button>
									<button
										// onClick={() => navigate(`/releases/calendar/`)}
										disabled
										type="button"
										class="rounded-e-lg mr-4 border text-slate-400 hover:text-cyan-700 border-slate-600 focus:outline-none focus:ring-2 focus:text-cyan-700 focus:ring-cyan-700 font-medium text-sm px-4 py-2 me-2 mb-2">
										Map
									</button>
								</div>
								<button
									onClick={() => setModalOpen(true)}
									type="button"
									class="pt-[6px] pb-[13px] border text-slate-400 hover:text-fuchsia-500 border-slate-600 focus:outline-none focus:ring-2 focus:text-violet-700 focus:ring-violet-700 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
									<svg
										class="mt-[6px] mb-[-4px]  w-[15px] h-[15px] fill-[#8e8e8e]"
										viewBox="0 0 576 512"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"></path>
									</svg>
								</button>
								<button
									onClick={() => setModalOpen(true)}
									type="button"
									class="border text-slate-400 hover:text-fuchsia-500 border-slate-600 focus:outline-none focus:ring-2 focus:text-violet-700 focus:ring-violet-700 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
									New Fan
								</button>
							</div>
						</div>
						<div class="shadow-xl bg-slate-500 p-4 rounded-lg tabpanel" id="profile" role="tabpanel" aria-labelledby="profile-tab">
							<MyDataTable onOpenForm={setModalOpen} onOpenConfiguration={setModalConfigOpen} />
						</div>
					</div>
				</div>

				<script src="https://unpkg.com/@themesberg/flowbite@1.2.0/dist/flowbite.bundle.js"></script>
				{/* <div className="text-2xl font-bold pt-14">
					Hello {currentUser.displayName ? currentUser.displayName : currentUser.email}, you are now logged in.
				</div> */}
			</div>
			<div className="h-screen flex items-center justify-center">
				<FormModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
			</div>
			<div className="h-screen flex items-center justify-center">
				<FormConfigurationModal isOpen={isModalConfigOpen} onClose={() => setModalConfigOpen(false)} />
			</div>
		</>
	);
};

export default Fans;
